import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BaseMessage } from "./BaseMessage.js";
import { useFieldContext } from "./FieldContext.js";
const HelpMessage = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { inputType, disabled } = useFieldContext() ?? {};
    const isHelpMessageDisabled = disabled && ('checkbox' === inputType || 'radio' === inputType || 'switch' === inputType);
    return /*#__PURE__*/ jsx(BaseMessage, {
        testId: "help-message",
        disabled: isHelpMessageDisabled,
        ...props,
        ref: ref
    });
});
HelpMessage.displayName = 'HelpMessage';
export { HelpMessage };
